import { PropsWithChildren } from 'react';
import { styled } from '@mui/material';

interface Props {
  isOpen: boolean;
  shrink: boolean;
}

const Container = styled('div')<Props>(
  ({ isOpen, shrink, theme: { palette } }) => ({
    zIndex: 1000,
    position: 'fixed',
    right: shrink ? 16 : 0,
    top: shrink ? 96 : 80,
    bottom: shrink ? undefined : 0,
    borderRadius: shrink ? 8 : 0,
    transform: 'translateX(100%)',
    transition: 'transform ease-in-out 300ms',

    backgroundColor: '#fff',
    boxShadow: '0px 7.5px 15px 0px #00000040',
    minWidth: !shrink ? 800 : undefined,
    width: shrink ? 400 : undefined,
    height: !shrink ? 'calc(100vh - 80px)' : 'auto',
    overflow: 'visible !important',

    ...(isOpen && {
      transform: 'translateX(0)',
    }),
  })
);

export default function ReportContainer({
  children,
  ...props
}: PropsWithChildren<Props>) {
  return <Container {...props}>{children}</Container>;
}
